/**
 * @param {import('@tiptap/core').Editor | null | undefined} editor
 * @returns {{ query: string, range: { from: number, to: number } } | null}
 */
export function getActiveMentionTrigger(editor) {
  if (!editor || editor.isDestroyed) return null

  const { state } = editor
  const { from, empty } = state.selection
  if (!empty) return null

  const $from = state.doc.resolve(from)
  const blockStart = $from.start()
  const textBefore = state.doc.textBetween(blockStart, from, '\n', '\ufffc')
  const match = /(?:^|[\s\n])@([^\s@]*)$/.exec(textBefore)
  if (!match) return null

  const query = match[1] ?? ''
  const atLocal = textBefore.lastIndexOf(`@${query}`)
  if (atLocal < 0) return null

  return {
    query,
    range: { from: blockStart + atLocal, to: from },
  }
}
